import { render, staticRenderFns } from "./CopyAddress.vue?vue&type=template&id=10ce0342&lang=pug"
import script from "./CopyAddress.vue?vue&type=script&lang=ts"
export * from "./CopyAddress.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports